var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var FixedFIFO = require('./fixed-size');

module.exports = /*#__PURE__*/function () {
  "use strict";

  function FastFIFO(hwm) {
    _classCallCheck(this, FastFIFO);

    this.hwm = hwm || 16;
    this.head = new FixedFIFO(this.hwm);
    this.tail = this.head;
  }

  _createClass(FastFIFO, [{
    key: "push",
    value: function push(val) {
      if (!this.head.push(val)) {
        var prev = this.head;
        this.head = prev.next = new FixedFIFO(2 * this.head.buffer.length);
        this.head.push(val);
      }
    }
  }, {
    key: "shift",
    value: function shift() {
      var val = this.tail.shift();

      if (val === undefined && this.tail.next) {
        var next = this.tail.next;
        this.tail.next = null;
        this.tail = next;
        return this.tail.shift();
      }

      return val;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.head.isEmpty();
    }
  }]);

  return FastFIFO;
}();